import type { InnerDatasetInterfaces } from "../types/inner-dataset-interfaces";

export class InnerDatasetFormatter {
  
  datasets: Record<string, { name: string, type: string, value: string }[][]> = {};

  fromDesignAtomsDataset(rawData: InnerDatasetInterfaces.DesignAtomsDataset) {
    let surface = 'Page_';
    let index = -1;
    let rawDatasets: { name: string, type: string, value: string }[][] = [];
    for (let surfaceData of rawData.vdpDataSet.surfacesData) {
      index++;
      surface += index;
      this.datasets[surface] ??= [];
      surfaceData.data.forEach((row) => {
        const embedRow = Object.entries(row).filter((r) => r[0] != "placeholders" && r[0] != "rootItems");
        const names = embedRow.map((r) => r[0]);
        const types = embedRow.map((r) => Object.keys(r[1])[0]);
        const values = embedRow.map((r) => Object.values(r[1])[0]);
        const dataset = names.map((name, idx) => ({
          name,
          type: types[idx],
          value: values[idx],
        }));
        rawDatasets.push(dataset);
      });
    };
    this.datasets[surface] = rawDatasets;
  }
}